import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=5bbf6c7e&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=5bbf6c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf6c7e",
  null
  
)

export default component.exports